import { render, staticRenderFns } from "./AllowanceEdit.vue?vue&type=template&id=8ce97eaa&scoped=true&"
import script from "./AllowanceEdit.vue?vue&type=script&lang=js&"
export * from "./AllowanceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce97eaa",
  null
  
)

export default component.exports